import React, { Component, useEffect, useState } from "react";
import ComponentTransactionDetailHistoryMobile from "./ComponentTransactionDetailHistoryMobile";
import ComponentTransactionDetailHistoryWeb from "./ComponentTransactionDetailHistoryWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentTransactionDetailHistory = () => {
  const gaEventTracker = useAnalyticsEventTracker("TransactionDetail");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Transaction Detail",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentTransactionDetailHistoryWeb></ComponentTransactionDetailHistoryWeb>
      </BrowserView>
      <MobileView>
        <ComponentTransactionDetailHistoryMobile></ComponentTransactionDetailHistoryMobile>
      </MobileView>
    </>
  );
};

export default ComponentTransactionDetailHistory;
